import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { 
  Modal, 
  Button, 
  Form, 
  ListGroup, 
  Pagination, 
  Spinner,
  Alert
} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { CLIENT_LIST_CREATE_URL, CLIENTS_URL } from '../apiConfig';
import './ClientModal.css';
import { toast } from 'react-toastify';
import { ConfirmDialog } from './ConfirmDialog';

const ClientModal = ({isOpen, onClose, onClientChange }) => {
  const [clients, setClients] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(4);
  const [formData, setFormData] = useState({
    clientName: '',
    payment: '',
    date: new Date().toISOString().split('T')[0]
  });
  const [editingId, setEditingId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  
  const theme = localStorage.getItem('theme') || 'light';
  const token = localStorage.getItem('token');
  const headers = { Authorization: `Token ${token}` };
  const [deleteDialog, setDeleteDialog] = useState({
    open: false,
    clientId: null,
    clientName: ''
  });

  const fetchClients = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${CLIENTS_URL}?page=${currentPage}&page_size=${pageSize}`,
        { headers }
      );
      console.log(response.data);
      setClients(response.data.results); //
      setTotalCount(response.data.count);
    } catch (err) {
      setError('Error al cargar clientes');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchClients();
  }, [currentPage]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { clientName, payment, date } = formData;
    
    if (!clientName || !payment || !date) {
      setError('Todos los campos son requeridos');
      return;
    }

    const endpoint = editingId 
      ? CLIENT_LIST_CREATE_URL.replace('<int:pk>', editingId)
      : CLIENTS_URL;

    try {
      const method = editingId ? 'put' : 'post';
      await axios[method](endpoint, {
        client_name: clientName,
        monthly_payment: payment,
        created_at: new Date(date).toISOString()
      }, { headers });

      toast.success(editingId ? 'Cliente actualizado' : 'Cliente agregado');
      fetchClients();
      resetForm();
    } catch (err) {
      setError('Error al procesar la solicitud');
    }
  };

  // const handleDelete = async (id) => {
  //   if (!window.confirm('¿Confirmar eliminación?')) return;
    
  //   try {
  //     await axios.delete(
  //       CLIENT_LIST_CREATE_URL.replace('<int:pk>', id),
  //       { headers }
  //     );
  //     setSuccess('Cliente eliminado');
  //     fetchClients();
  //   } catch (err) {
  //     setError('Error al eliminar');
  //   }
  // };

  const resetForm = () => {
    setFormData({
      clientName: '',
      payment: '',
      date: new Date().toISOString().split('T')[0]
    });
    setEditingId(null);
  };

  const handleEdit = (client) => {
    setFormData({
      clientName: client.client_name,
      payment: client.monthly_payment,
      date: client.created_at.split('T')[0]
    });
    setEditingId(client.id);
  };

  const PaginationControls = () => {
    const totalPages = Math.ceil(totalCount / pageSize);
    
    return (
      <Pagination className="mt-3 justify-content-center">
        <Pagination.Prev 
          onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
          disabled={currentPage === 1}
        />
        
        {Array.from({ length: totalPages }, (_, i) => (
          <Pagination.Item
            key={i + 1}
            active={i + 1 === currentPage}
            onClick={() => setCurrentPage(i + 1)}
          >
            {i + 1}
          </Pagination.Item>
        ))}
        
        <Pagination.Next 
          onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
          disabled={currentPage >= totalPages}
        />
      </Pagination>
    );
  };
  const handleDelete = (client) => {
    // console.log(client);
    setDeleteDialog({
      open: true,
      clientId: client.id,
      clientName: client.client_name
    });
  };
  return (
    <>
    <Modal show={isOpen} onHide={onClose} centered 
      size="xl"
      backdrop="static"
      dialogClassName='large-modal-width'
      className={`custom-modal ${theme === 'dark' ? 'bg-dark text-white' : ''}`}
    >
      <Modal.Header closeButton className={`large-modal-width ${theme === 'dark' ? 'bg-dark text-white' : ''}`}>
        <Modal.Title>Gestión de Clientes</Modal.Title>
      </Modal.Header>
      
      <Modal.Body className={`large-modal-width ${theme === 'dark' ? 'bg-dark text-white' : ''}`}>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Nombre del cliente</Form.Label>
            <Form.Control
              value={formData.clientName}
              onChange={(e) => setFormData({ ...formData, clientName: e.target.value })}
              placeholder="Ingrese el nombre"
            />
          </Form.Group>

          <div className="row">
            <div className="col-md-6 mb-3">
              <Form.Label>Pago mensual</Form.Label>
              <Form.Control
                type="number"
                value={formData.payment}
                onChange={(e) => setFormData({ ...formData, payment: e.target.value })}
                placeholder="Monto"
                className="m-0" 
              />
            </div>
            
            <div className="col-md-6 mb-3">
              <Form.Label
              className=''
              >Fecha</Form.Label>
              <Form.Control
                type="date"
                value={formData.date}
                onChange={(e) => setFormData({ ...formData, date: e.target.value })}
              />
            </div>
          </div>

          <div className="d-flex justify-content-end gap-2">
            <Button variant="secondary" onClick={resetForm}>
              Limpiar
            </Button>
            <Button variant="primary" type="submit"
            onClick={() =>       
              {setLoading(true);}
                          }>
              {editingId ? 'Guardar Cambios' : 'Agregar Cliente'}
            </Button>
          </div>
        </Form>

        {error && <Alert variant="danger" className="mt-3">{error}</Alert>}
        {success && <Alert variant="success" className="mt-3">{success}</Alert>}

        <div className="mt-4">
          <h5>Listado de Clientes</h5>
          
          {loading ? (
            <div className="text-center py-4">
              <Spinner animation="border" />
            </div>
          ) : (
            <>
              <ListGroup>
                {clients.map(client => (
                  <ListGroup.Item 
                    key={client.id}
                    className={theme === 'dark' ? 'bg-secondary text-white' : ''}
                  >
                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <strong>{client.client_name}</strong> - ${client.monthly_payment}
                        <div className="text-muted small">
                          {new Date(client.created_at).toLocaleDateString('es-ES')}
                        </div>
                      </div>
                      
                      <div className="d-flex gap-2">
                        <Button 
                          variant="link" 
                          onClick={() => handleEdit(client)}
                          className="text-primary"
                        >
                          <FontAwesomeIcon icon={faEdit} />
                        </Button>
                        <Button 
                          variant="link" 
                          onClick={() => handleDelete(client)}
                          className="text-danger"
                        >
                          <FontAwesomeIcon icon={faTrashAlt} />
                        </Button>
                      </div>
                    </div>
                  </ListGroup.Item>
                ))}
              </ListGroup>

              {clients.length === 0 && !loading && (
                <Alert variant="info" className="mt-3">
                  No se encontraron clientes
                </Alert>
              )}

              {totalCount > pageSize && <PaginationControls />}
              
              <div className="text-center mt-2 text-muted small">
                Mostrando {clients.length} de {totalCount} registros
              </div>
            </>
          )}
        </div>
      </Modal.Body>
      
      <Modal.Footer className={`large-modal-width ${theme === 'dark' ? 'bg-dark text-white' : ''}`}>
        <Button variant="secondary" onClick={onClose}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
    <ConfirmDialog
          open={deleteDialog.open}
          title="Confirmar eliminación"
          message={`¿Estás seguro que deseas eliminar el cliente ${deleteDialog.clientName}? Esta acción no se puede deshacer.`}
          onConfirm={async () => {
            setLoading(true);
            try {
              await axios.delete(
                CLIENT_LIST_CREATE_URL.replace('<int:pk>', deleteDialog.clientId),
                { headers }
              );
              toast.success('Cliente eliminado');
              fetchClients();
            } catch (err) {
              setError('Error al eliminar');
            }
            setLoading(false);
            setDeleteDialog({ open: false });
          }}
          loading={loading}
          onCancel={() => setDeleteDialog({ open: false })}
        />
  </>
  );
};

export default ClientModal;